var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteNumeric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lucide / delete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3331 6.6656C12.6705 6.66564 12.0316 6.91235 11.5409 7.35768L3.10289 15.0119C2.96518 15.1369 2.85513 15.2893 2.77982 15.4594C2.7045 15.6294 2.6656 15.8133 2.6656 15.9993C2.6656 16.1853 2.7045 16.3693 2.77982 16.5393C2.85513 16.7094 2.96518 16.8618 3.10289 16.9868L11.5409 24.6423C12.0316 25.0876 12.6705 25.3344 13.3331 25.3344H26.6675C27.3748 25.3344 28.0532 25.0534 28.5533 24.5533C29.0534 24.0531 29.3344 23.3748 29.3344 22.6674V9.33257C29.3344 8.62525 29.0534 7.94689 28.5533 7.44674C28.0532 6.94658 27.3748 6.6656 26.6675 6.6656H13.3331Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#111827"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16 12L24 20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#111827"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24 12L16 20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#111827"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteNumeric);
export default __webpack_public_path__ + "static/media/delete-numeric.b981ccf268df7787d339dcac8a9b408a.svg";
export { ForwardRef as ReactComponent };